import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "./AuthShell";
import { useAuth } from "../../context/AuthContext";
import { apiErr } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", identifier: "", password: "", confirm_password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.identifier.trim()) { toast.error("Enter your email address or mobile number."); return; }
    if (form.password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    if (form.password !== form.confirm_password) { toast.error("Password and confirmation do not match."); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created. Let's set things up.");
      nav("/onboarding");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Sign up in seconds — create your password and you're straight in."
      footer={<>Already have an account? <Link to="/signin" className="text-mint underline underline-offset-4">Sign in</Link>.</>}>
      <form onSubmit={submit} className="space-y-4">
        <div><Label htmlFor="reg-name" className="text-ink">Full name</Label><Input id="reg-name" name="name" autoComplete="name" required value={form.name} onChange={set("name")} className="mt-1.5 rounded-xl" data-testid="register-name" /></div>
        <div><Label htmlFor="reg-identifier" className="text-ink">Email or mobile number</Label><Input id="reg-identifier" name="username" autoComplete="username" required value={form.identifier} onChange={set("identifier")} className="mt-1.5 rounded-xl" placeholder="you@email.com or 98765 43210" data-testid="register-identifier" /></div>
        <div><Label htmlFor="reg-password" className="text-ink">Password <span className="text-muted-foreground font-normal">(min 8 characters)</span></Label><Input id="reg-password" name="new-password" type="password" autoComplete="new-password" minLength={8} required value={form.password} onChange={set("password")} className="mt-1.5 rounded-xl" data-testid="register-password" /></div>
        <div><Label htmlFor="reg-confirm" className="text-ink">Confirm password</Label><Input id="reg-confirm" name="confirm-password" type="password" autoComplete="new-password" minLength={8} required value={form.confirm_password} onChange={set("confirm_password")} className="mt-1.5 rounded-xl" data-testid="register-confirm" /></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full bg-navy text-white hover:bg-navy-light h-11" data-testid="register-submit">
          {loading ? "Creating…" : "Create account"}
        </Button>
      </form>
    </AuthShell>
  );
}
